// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var MenuV5 = require("../../../common/Components/menu/MenuV5.bs.js");
var Scalars = require("../../../../scalars/Scalars.bs.js");
var UTCDate = require("../../../../reason/common/types/UTCDate.bs.js");
var ViewStack = require("../../../../reason/common/ViewStack.bs.js");
var Text__Jsx3 = require("../../../../uikit/reason/helpers/Text__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var DuplicatePropertyError = require("./DuplicatePropertyError.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyAddressValidationCallout = require("./PropertyAddressValidationCallout.bs.js");
var DuplicateQuietPropertyError_quietProperty_graphql = require("../../../../__generated__/DuplicateQuietPropertyError_quietProperty_graphql.bs.js");

var convertFragment = DuplicateQuietPropertyError_quietProperty_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, DuplicateQuietPropertyError_quietProperty_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(DuplicateQuietPropertyError_quietProperty_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, DuplicateQuietPropertyError_quietProperty_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(DuplicateQuietPropertyError_quietProperty_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function DuplicateQuietPropertyError(props) {
  var property = use(props.property);
  return JsxRuntime.jsxs(PropertyAddressValidationCallout.make, {
              heading: "You already have a property with this address on TAN",
              children: [
                JsxRuntime.jsx(Text__Jsx3.make, {
                      lineHeight: {
                        NAME: "float",
                        VAL: 1.50
                      },
                      children: JsxRuntime.jsxs("p", {
                            children: [
                              "You added a quiet property at ",
                              JsxRuntime.jsx("strong", {
                                    children: property.address + ", " + property.area.label
                                  }),
                              " to TAN " + UTCDate.formatDistanceFromNow(true, Scalars.DateTime.toUTC(property.createdAt)) + " ago. ",
                              "Click below to view, edit, or broadcast it"
                            ]
                          })
                    }),
                JsxRuntime.jsxs(ViewStack.make, {
                      pt: "sm",
                      space: "sm",
                      justifyContent: "flexEnd",
                      flexDirection: "row",
                      children: [
                        JsxRuntime.jsx(DuplicatePropertyError.ViewClientButton.make, {
                              clientId: property.client.id
                            }),
                        JsxRuntime.jsxs(DuplicatePropertyError.ActionsDropdown.make, {
                              children: [
                                JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                      href: "/properties/" + property.id + "/edit",
                                      children: "Edit Quiet Property"
                                    }),
                                JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                      href: "/properties/" + property.id + "/broadcast",
                                      children: "Broadcast Quiet Property"
                                    })
                              ]
                            })
                      ]
                    })
              ],
              icon: "Warning"
            });
}

var make = DuplicateQuietPropertyError;

exports.Fragment = Fragment;
exports.make = make;
/* MenuV5 Not a pure module */
